export const dossiers = [
  {
    id: 'd-01',
    title: '选秀旧账',
    subtitle: '从选秀期争议到出道后翻车',
    desc: '把同一批选秀出身的争议集中成一条，出道前后的话术变化一目了然。',
    image:
      'https://readdy.ai/api/search-image?query=Dark%20editorial%20abstract%20composition%20with%20shattered%20glass%20texture%20over%20deep%20crimson%20gradient%20background%2C%20moody%20studio%20lighting%2C%20high%20contrast%20minimal%2C%20cinematic%20grain%2C%20no%20people&width=900&height=650&seq=snhe-dossier-01&orientation=landscape',
    tags: ['塌房', '数据造假'],
    count: 32,
    updated: '09-10 00:42',
  },
  {
    id: 'd-02',
    title: '舞台翻车合集',
    subtitle: '演出事故与临场改词',
    desc: '按场次记录每一次翻车，包含现场处理和后续是否致歉。',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20dark%20scene%20of%20overturned%20stage%20lighting%20equipment%20silhouette%20against%20amber%20haze%2C%20moody%20minimal%20editorial%20photography%20style%2C%20deep%20shadows%2C%20warm%20gold%20glow%2C%20no%20people&width=900&height=650&seq=snhe-dossier-02&orientation=landscape',
    tags: ['翻车', '合作纠纷'],
    count: 28,
    updated: '09-09 23:58',
  },
  {
    id: 'd-03',
    title: '言论与立场',
    subtitle: '被翻出的旧采访与旧动态',
    desc: '只放可核对的原文与时间，不带二次解读，方便自己判断。',
    image:
      'https://readdy.ai/api/search-image?query=Two-tone%20abstract%20split%20composition%2C%20deep%20crimson%20and%20charcoal%20with%20torn%20paper%20edge%20texture%2C%20minimalist%20editorial%20magazine%20art%2C%20dramatic%20side%20lighting%2C%20no%20people&width=900&height=650&seq=snhe-dossier-03&orientation=landscape',
    tags: ['争议', '言论失当'],
    count: 41,
    updated: '09-09 22:31',
  },
  {
    id: 'd-04',
    title: '作品重合线',
    subtitle: '旋律、分镜与文案比对',
    desc: '把争议作品与原作并排放，标出重合段落和对外的回应口径。',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20blurred%20newsprint%20texture%20on%20dark%20charcoal%20background%20with%20amber%20spotlight%2C%20investigative%20dossier%20mood%2C%20high%20contrast%2C%20film%20grain%2C%20no%20people&width=900&height=650&seq=snhe-dossier-04&orientation=landscape',
    tags: ['抄袭', '冷处理'],
    count: 19,
    updated: '09-09 21:05',
  },
  {
    id: 'd-05',
    title: '合作与合约',
    subtitle: '解约、换角与排期冲突',
    desc: '每一条都写清楚时间节点、双方说法和最后落到哪个结果。',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20overlapping%20translucent%20layers%20in%20muted%20sage%20cream%20and%20deep%20ink%20tones%2C%20minimalist%20geometric%20editorial%20art%2C%20soft%20light%2C%20no%20people&width=900&height=650&seq=snhe-dossier-05&orientation=landscape',
    tags: ['合作纠纷', '选角风波'],
    count: 24,
    updated: '09-09 20:12',
  },
  {
    id: 'd-06',
    title: '代言与品牌',
    subtitle: '违规、换物与联动删除',
    desc: '品牌方的处理速度往往比艺人本人更快，这里按小时记录。',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20dark%20stage%20curtain%20folds%20in%20deep%20crimson%20with%20single%20amber%20spotlight%20beam%2C%20dramatic%20theater%20mood%2C%20high%20contrast%2C%20cinematic%2C%20no%20people&width=900&height=650&seq=snhe-dossier-06&orientation=landscape',
    tags: ['违规代言', '翻车'],
    count: 15,
    updated: '09-09 19:47',
  },
];